export default "__VITE_ASSET__c18eb4f9__"